"use strict";

let container, readMoreBtn, aboutTextElements, aboutMessage;
let isTextExpanded = false;

function initAbout() {
    aboutTextElements = document.querySelectorAll(".about__inner__text-container > p");
    aboutMessage = Array.from(aboutTextElements).map(element => element.textContent).join("\n\n");
    readMoreBtn = document.getElementById("read__more__btn");
    container = document.querySelector(".about__inner__text-container");

    if (!readMoreBtn) {
        console.error("Read more button not found.");
        return;
    }

    const maxLength = 105;

    function handleReadMore() {
        if (window.innerWidth <= 750) {
            let truncatedText = aboutMessage.slice(0, maxLength);

            if (aboutMessage.length > maxLength) {
                if (!isTextExpanded) {
                    updateText(truncatedText + "...", true);
                    readMoreBtn.style.display = "inline-block";
                    readMoreBtn.textContent = "続きを読む";
                }

                readMoreBtn.onclick = function () {
                    if (!isTextExpanded) {
                        updateText(aboutMessage, false);
                        readMoreBtn.textContent = "閉じる";
                        updatePseudoElement(false);
                        isTextExpanded = true;
                    } else {
                        updateText(truncatedText + "...", true);
                        readMoreBtn.textContent = "続きを読む";
                        updatePseudoElement(true);
                        isTextExpanded = false;
                    }
                };
            } else {
                updateText(aboutMessage, false);
                readMoreBtn.style.display = "none";
            }
        } else {
            updateText(aboutMessage, false);
            readMoreBtn.style.display = "none";
            isTextExpanded = true;
        }
    }

    function updateText(text, truncate) {
        if (truncate) {
            aboutTextElements[0].textContent = text;
            for (let i = 1; i < aboutTextElements.length; i++) {
                aboutTextElements[i].textContent = '';
            }
        } else {
            const paragraphs = text.split("\n\n");
            aboutTextElements.forEach((element, index) => {
                if (index < paragraphs.length) {
                    element.textContent = paragraphs[index];
                } else {
                    element.textContent = '';
                }
            });
        }
    }

    function updatePseudoElement(isClosed) {
        if (isClosed) {
            container.style.setProperty("--bottom-value", "-40%");
        } else {
            container.style.setProperty("--bottom-value", "-13%");
        }
        sessionStorage.setItem('pseudoElementState', isClosed);
    }

    function resetAboutState() {
        isTextExpanded = false;
        handleReadMore();
        updatePseudoElement(true);
    }

    // 初期状態の設定
    const savedState = sessionStorage.getItem('pseudoElementState');
    isTextExpanded = savedState === 'false';
    updatePseudoElement(!isTextExpanded);

    handleReadMore();
    window.addEventListener("resize", handleReadMore);

    // Intersection Observer の設定
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                resetAboutState();
            }
        });
    }, { threshold: 0.1 });

    observer.observe(container);

    // visibilitychange イベントリスナー
    document.addEventListener('visibilitychange', function() {
        if (!document.hidden && container) {
            resetAboutState();
        }
    });

    // フルスクリーン変更イベントリスナーを追加
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    function handleFullscreenChange() {
        if (!document.fullscreenElement && !document.webkitFullscreenElement &&
            !document.mozFullScreenElement && !document.msFullscreenElement) {
            setTimeout(resetAboutState, 100);
        }
    }
}

document.addEventListener("DOMContentLoaded", initAbout);

// 新しいイベントリスナーを追加
document.addEventListener('videoFullscreenExit', function() {
    setTimeout(resetAboutState, 100);
});
